import { render, staticRenderFns } from "./update-ticket.vue?vue&type=template&id=3b1cb680"
import script from "./update-ticket.vue?vue&type=script&lang=js"
export * from "./update-ticket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports